<template>
  <div class="personal-container">
    <div class="row section-type-s pt-5">
      <div class="col-12 col-lg-5 vertical-align">
        <div>
          <h1 class="text-light mb-24">
            Encuentra el auto perfecto para ti en Grupo Felix Agencia Automotriz
          </h1>
          <p class="text-light mb-32">
            Grupo Felix se ocupará de todas tus necesidades para asegurarte el mejor servicio
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-7 presentation-inner-padding-top ">
        <div>
          <div class="owl-carousel carousel-principal-cars">
            <div class="carrousel-element">
              <div class="car-x2">
                <img :src="random.length >= 2 ? random[1].portada : ''" class="w-100 ml-config blazer2020_1231" alt="Chevrolet Blazer color rojo">
                <br>
                <div class="d-flex justify-content-end mb-24 color-selectors">
                  <span v-bind:key="color.color" v-for="(color) in (random.length >= 2 ? random[1].colores : [])" :style="{backgroundColor: color.color}" class="pointer-color-selector white" @click="setSparkColor('spark2020_1231',color.color, color.portada, 1)"></span>
                </div>
              </div>

              <div class="description-x2">
                <h2 class="text-right text-light mb-16">
                    {{random.length >= 2 ? random[1].nombre : ''}}
                </h2>
                <h3 class="text-right text-light mb-16">
                  desde <strong><sub></sub> <span style="color: #e8aa37;">{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(random.length >= 1 ? random[1].contado : '00') }}</span> <sup>MXN</sup> </strong>
                </h3>
                <!-- <h6 class="text-right text-light">Cinco versiones disponibles (LT, LT CVT,
                  Premiere, Premiere CVT y ACTIV)</h6>
                <p class="text-right text-light">Faros delantes con proyección de halógeno</p>
                <p class="text-right text-light">Faros de niebla cromados (ACTIV)</p>
                <p class="text-right text-light">Luces diurnas de LED (Premier)</p>
                <p class="text-right text-light">10 colores disponibles</p> -->
              </div>
            </div>

             <div class="carrousel-element">
              <div class="car-x2">
                <img :src="random.length >= 2 ? random[2].portada : ''" class="w-100 ml-config blazer2020_1231" alt="Chevrolet Blazer color rojo">
                <br>
                <div class="d-flex justify-content-end mb-24 color-selectors">
                  <span v-bind:key="color.color" v-for="(color) in (random.length >= 2 ? random[2].colores : [])" :style="{backgroundColor: color.color}" class="pointer-color-selector white" @click="setSparkColor('spark2020_1231',color.color, color.portada, 2)"></span>
                </div>
              </div>
              <div class="description-x2">
                <h2 class="text-right text-light mb-16">
                    {{random.length >= 2 ? random[2].nombre : ''}}
                </h2>
                <h3 class="text-right text-light mb-16">
                  desde <strong><sub></sub> <span style="color: #e8aa37;">{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(random.length >= 1 ? random[2].contado : '00') }}</span> <sup>MXN</sup> </strong>
                </h3>
                <!-- <h6 class="text-right text-light">Cinco versiones disponibles (LT, LT CVT,
                  Premiere, Premiere CVT y ACTIV)</h6>
                <p class="text-right text-light">Faros delantes con proyección de halógeno</p>
                <p class="text-right text-light">Faros de niebla cromados (ACTIV)</p>
                <p class="text-right text-light">Luces diurnas de LED (Premier)</p>
                <p class="text-right text-light">10 colores disponibles</p> -->
              </div>
            </div>

             <div class="carrousel-element">
              <div class="car-x2">
                <img :src="random.length >= 2 ? random[3].portada : ''" class="w-100 ml-config blazer2020_1231" alt="Chevrolet Blazer color rojo">
                <br>
                <div class="d-flex justify-content-end mb-24 color-selectors">
                  <span v-bind:key="color.color" v-for="(color) in (random.length >= 2 ? random[1].colores : [])" :style="{backgroundColor: color.color}" class="pointer-color-selector white" @click="setSparkColor('spark2020_1231',color.color, color.portada,3)"></span>
                </div>
              </div>
              <div class="description-x2">
                <h2 class="text-right text-light mb-16">
                    {{random.length >= 2 ? random[3].nombre : ''}}
                </h2>
                <h3 class="text-right text-light mb-16">
                   <strong><sub></sub> <span style="color: #e8aa37;">{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(random.length >= 1 ? random[3].contado : '00') }}</span> <sup>MXN</sup> </strong>
                </h3>
                <!-- <h6 class="text-right text-light">Cinco versiones disponibles (LT, LT CVT,
                  Premiere, Premiere CVT y ACTIV)</h6>
                <p class="text-right text-light">Faros delantes con proyección de halógeno</p>
                <p class="text-right text-light">Faros de niebla cromados (ACTIV)</p>
                <p class="text-right text-light">Luces diurnas de LED (Premier)</p>
                <p class="text-right text-light">10 colores disponibles</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import blue from '@/assets/images/autos/chevrolet/blazer/blue.png'
import black from '@/assets/images/autos/chevrolet/blazer/black.png'
import red from '@/assets/images/autos/chevrolet/blazer/red.png'
import Vue from 'vue'

// import white from '@/assets/images/autos/chevrolet/spark/white.png'
// import grey from '@/assets/images/autos/chevrolet/spark/grey.png'
// import sblack from '@/assets/images/autos/chevrolet/spark/black.png'
// import orange from '@/assets/images/autos/chevrolet/spark/orange.png'
// import silver from '@/assets/images/autos/chevrolet/spark/silver.png'
// import sred from '@/assets/images/autos/chevrolet/spark/red.png'

export default {
  name: 'Banner',
  data () {
    return {
      urlImageSpark: require('@/assets/images/autos/chevrolet/spark/orange.png'),
      urlImageBlazer: require('@/assets/images/autos/chevrolet/blazer/red.png')
    }
  },
  props: {
    random: Array
  },
  methods: {
    setBlazerColor (arg1, arg2, arg3) {
      if (!arg3) {
        this.urlImageBlazer = require('@/assets/images/autos/default.png')
      } else {
        switch (arg2) {
          case 'blue':
            this.urlImageBlazer = blue
            break
          case 'black':
            this.urlImageBlazer = black
            break
          case 'red':
            this.urlImageBlazer = red
            break
        }
      }
    },
    setSparkColor (arg1, arg2, portada, idex) {
      Vue.set(this.random[idex], 'portada', portada)
    }
  }
}
</script>

<style scoped>

</style>
